import { useQuery } from '@tanstack/react-query';

import { fetchSortingFields } from '../../data-provider/select-options';

export const useGetSortingFields = () => {
  return useQuery({
    queryFn: () => fetchSortingFields(),
    queryKey: ['claims-loss-and-damage-sorting-fields'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
